<template>
    <apexchart width="100%" type="area" height="220" :options="chartOptions" :series="series" ref="lineChart"></apexchart>
</template>

<script>
import moment from 'moment'
    export default {
        name: 'line-chart',
        props: {
            data: {
                type: Array
            },
            categories: {
                type: Array
            }
        },
        data (props) {
            return {
                series: [{
                    data: this.data
                }],
                chartOptions: {
                    type: 'area',
                    dataLabels: {
                        enabled: false
                    },
                    fill: {
                        type: 'solid',
                        colors: ['#F4C999'],
                        gradient: {
                            shadeIntensity: 1,
                            opacityFrom: 1,
                            opacityTo: 1,
                            stops: [0, 90, 100]
                        }
                    },
                    stroke: {
                        curve: 'smooth',
                        width: 1
                    },
                    xaxis: {
                        categories: [],
                        labels: {
                            show: true,
                            rotate: -25,
                            rotateAlways: true,
                            style: {
                                colors: '#999',
                                fontSize: '9px',
                                fontFamily: 'Nunito-Regular, sans-serif'
                            }
                        }
                    },
                    yaxis: {
                        labels: {
                            show: true,
                            style: {
                                colors: '#999',
                                fontSize: '9px',
                                fontFamily: 'Nunito-Regular, sans-serif'
                            },
                            formatter: function (val) {
                                if (val >= 1 || val === 0) {
                                    return val.toFixed(0)
                                } else {
                                    return val.toFixed(2)
                                }
                            }
                        }
                    },
                    grid: {
                        borderColor: '#eee'
                    },
                    theme: {
                        monochrome: {
                            enabled: true,
                            color: '#E47700',
                            shadeTo: 'light',
                            shadeIntensity: 0.9
                        }
                    },
                    chart: {
                        id: 'line-chart',
                        toolbar: {
                            show: true,
                            tools: {
                                download: false,
                                selection: true,
                                zoom: true,
                                zoomin: true,
                                zoomout: true,
                                pan: true,
                                reset: true,
                                customIcons: []
                            }
                        }
                    }
                }
            }
        },
        methods: {
            updateSeries () {
                ApexCharts.exec('line-chart', 'updateSeries', [
                    {
                        data: this.data,
                        name: this.$t('OrganizationReport.total_hours_watched_graph_label')
                    }
                ])
            },
            updateXaxis () {
                ApexCharts.exec('line-chart', 'updateOptions', {
                    xaxis: {
                        categories: this.categories
                    }
                })
            }
        },
        watch: {
            data: {
                handler: 'updateSeries'
            },
            categories: {
                handler: 'updateXaxis'
            }
        },
        beforeDestroy () {
            this.$refs.lineChart.$destroy()
        }
    }
</script>
